/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "zsberbzbcluswsutfhul";
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpzYmVyYnpiY2x1c3dzdXRmaHVsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1MDIxODgsImV4cCI6MjA4ODA3ODE4OH0.q3vdj3unHiamNwyedOFSzeAC-hkT3M91QgwZ3AfjrNs";
